import React from 'react';
import { RadioButtonProps } from '../radio-button/radio-button';

export type RadioButtonGroupProps = {
    testId?: string;
    ariaLabel?: string;
    orientation?: 'horizontal' | 'vertical';
    children: React.ReactNode;
    className?: string;
    value?: string;
    onChange?: (value: string) => void;
};

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
    testId,
    ariaLabel,
    orientation = 'vertical', // default
    className,
    children,
    value,
    onChange,
}) => {
    const flexDirection = orientation === 'horizontal' ? 'flex-row' : 'flex-col';

    const [selectedValue, setSelectedValue] = React.useState<string | undefined>(value);

    React.useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const handleSelectionChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.defaultValue);
        onChange && onChange(event.target.defaultValue);
    }, []);

    return (
        <div data-testid={testId} aria-label={ariaLabel} className={`flex ${flexDirection} gap-2 ${className}`}>
            {React.Children.map(children, (child) => {
                if (React.isValidElement<RadioButtonProps>(child)) {
                    return React.cloneElement(child, {
                        checked: child.props.value === selectedValue, // Mark the selected child
                        onChange: handleSelectionChange,
                    });
                }
                return child;
            })}
        </div>
    );
};
